<section>
  <remote-update-domain-multi-step-form
    [modelTitle]="'Rollout Plan'"
    [store]="store"
    [menuItems]="rolloutPlanMenu()"
    (formCancel)="onCancel()"
    (nextStep)="goToNextStep()"
    [actionButtonLabel]="actionButtonLabel"
    [finalButtonText]="'Create rollout plan'">
    @if (isLoading()) {
    <mat-progress-bar mode="indeterminate" value="50" color="primary"></mat-progress-bar>
    }
    <remote-update-domain-app-plan-details [currentSection]="currentSection" />
    <remote-update-domain-app-target-product-groups [currentSection]="currentSection" />
    <remote-update-domain-app-distribution-settings [currentSection]="currentSection" />
    <remote-update-domain-app-rollout-plan-summary [currentSection]="currentSection" />
  </remote-update-domain-multi-step-form>
</section>
